import * as React from 'react';
import {createTheme, ThemeOptions} from '@mui/material/styles';
import {createStyles, makeStyles} from "@mui/styles";
import {GridCellParams} from "@mui/x-data-grid";


const defaultTheme = createTheme();
const useStyles = makeStyles(
    (theme: { palette: { divider: any; }}) =>
        createStyles({
            root: {
                border: `1px solid ${theme.palette.divider}`,
                position: 'relative',
                overflow: 'hidden',
                width: '80%',
                height: 26,
                borderRadius: 30,
            },
            value: {
                position: 'absolute',
                lineHeight: '24px',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                color: "#11347B"
            },
            bar: {
                height: '100%',
                backgroundColor: "#00A3E5"
            },
        }),
    { defaultTheme }
);

interface ProgressBarProps {
    value?: number
    percentage: number
    width?: string
}

const ProgressBar = React.memo(function ProgressBar(props: ProgressBarProps) {
    const { value } = props
    const { percentage } = props
    const { width } = props
    // @ts-ignore
    const classes = useStyles()


    if (value !== undefined){
        return (
            <div className={classes.root} style={{width: width ? `${width}%` : "80%"}}>
                <div className={classes.value}>{`${value.toLocaleString()}`}</div>
                <div
                    className={classes.bar}
                    style={{ maxWidth: `${(value*100)/5}%` }}
                />
            </div>
        );
    }

    return (
        <div className={classes.root} style={{width: width ? `${width}%` : "80%"}}>
            <div className={classes.value}>{`${percentage.toLocaleString()} %`}</div>
            <div
                className={classes.bar}
                style={{ maxWidth: `${percentage}%` }}
            />
        </div>
    );

});

export function renderProgress(percentage: number, value?: number, width?: string) {
    return <ProgressBar percentage={Number(percentage)!} value={value} width={width}/>;
}
